<template>
  <!-- <page-common type="normal" :showAppTopLink="isSharePage" :showAppBotLink="isSharePage" :detail="data1"> -->
    <div class="wrapper">
      <van-pull-refresh 
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <div class="hours_header">
          <img class="bg_header_img"
            :style="'background:#F6F6F6'"
            src="../images/bg.png"
            @load="loadImg"
            ref="imgHight"
          />
        </div>
        <!-- 列表区 -->
        <section class="tab_list" id="list_scroll">
            <van-tabs v-model="active" v-if="data_.length>0 || dataList.length>0" @click="changeID" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="50">
              <van-tab  v-for="(v,index) in (data_.slice(0,1))" :key="index" :title="v.categoryInfo.name" >
                <ul>
                  <div v-for="(i,index) in v.list" :key="index">
                    <h2 style="margin:25px 0" class='date_'>{{index}}</h2>
                    <div v-for="(article,index) in i" :key="index" class="hours_list">
                      <div class='time_red'>{{getTime(article.date)}}</div>
                      <li class="flex flex-main-justify" @click="goPath(article)">
                        <div class="info" style='width:100%'>
                          <div :class='["title", "mult_line_ellipsis",article.images && article.images.length>0?"min_height":""]'><span class="tag_label_2" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.title}}</div>
                          <!-- <div class="flex">  -->
                            <div class="flex date">
                                <!-- <div class="tag ellipsis" style=' justify-content: flex-start'>
                                    <span 
                                        class="tag-red"  
                                        v-if="article.type !='subject'" v-html="article.tags"
                                    ></span>
                                    <span v-html="article.source"></span>
                                </div> -->
                                <!-- <time>{{article.date}}</time> -->
                                <time>{{getDate(article.date) | dateComparedTime}}</time>
                                <span class='hours_tag likes_'>{{getCount(article.likes)}}</span>
                                <span class='comments hours_tag'>{{getCount(article.comments)}}</span>
                                
                            </div>
                          <!-- </div> -->
                        </div>
                        <div class="thumbnail" :style="{backgroundImage: 'url(' + article.images[0] + ')'}" v-if="article.images">
                        <i :class="[article.type+'-icon']"></i>
                        </div>
                      </li>
                    </div>
                  </div>
                </ul>
              </van-tab>
              <!-- <van-tab title="标签 3">内容 3</van-tab> -->
              <van-tab  v-for="(v) in nav" :key="v.id" :title="v.name" >
                <ul>
                  <div v-for="(i,index) in dataList.list" :key="index">
                    <h2 style="margin:25px 0" class='date_'>{{index}}</h2>
                    <div v-for="(article,index) in i" :key="index" class="hours_list">
                      <div class='time_red'>{{getTime(article.date)}}</div>
                      <li class="flex flex-main-justify" @click="goPath(article)">
                        <div class="info" style='width:100%'>
                          <div :class='["title", "mult_line_ellipsis",article.images && article.images.length>0?"min_height":""]'><span class="tag_label_2" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.title}}</div>
                          <!-- <div class="flex">  -->
                            <div class="flex date">
                                <!-- <div class="tag ellipsis" style=' justify-content: flex-start'>
                                    <span 
                                        class="tag-red"  
                                        v-if="article.type !='subject'" v-html="article.tags"
                                    ></span>
                                    <span v-html="article.source"></span>
                                </div> -->
                                <!-- <time>{{article.date}}</time> -->
                                <time>{{getDate(article.date) | dateComparedTime}}</time>
                                <span class='hours_tag likes_'>{{getCount(article.likes)}}</span>
                                <span class='comments hours_tag'>{{getCount(article.hits)}}</span>
                                
                            </div>
                          <!-- </div> -->
                        </div>
                        <div class="thumbnail" :style="{backgroundImage: 'url(' + article.images[0] + ')'}" v-if="article.images">
                        <i :class="[article.type+'-icon']"></i>
                        </div>
                      </li>
                    </div>
                  </div>
                </ul>
              </van-tab>

            </van-tabs>
            <div v-if="noData==0 || noData_==0" class="null-data" style='text-align: center'>暂无相关内容</div>
            <p v-if="loading" class="loading" style="text-align: center">
              <spinner type="fading-circle"></spinner>
              加载中...
            </p>
            <p v-if="isAll" class="loading" style='text-align: center;margin-bottom: 50px;'>已显示全部内容</p>
                
            <!-- <p>刷新次数: {{ count }}</p>  && noData!==0 || noData_!==0-->
        
        </section>
      </van-pull-refresh>
    </div>
  <!-- </page-common> -->
</template>

<script>
  import api from 'src/constants/appapi'
  import Tab from 'vant/lib/tab';
  import Tabs from 'vant/lib/tabs';
  import PullRefresh from 'vant/lib/pull-refresh';
  import 'vant/lib/tab/style';
  import 'vant/lib/tabs/style';
  import 'vant/lib/pull-refresh/style';
  import wx from '../services/weChatShare';
  import PageCommon from './page-common'
  import { Toast,Spinner } from 'mint-ui'
  import { intfc_prefix_common } from 'constants/project'
    export default {
      name:'Hours',
      data () {
        return {
          blocks: [],
          active: 0,
          count: 0,
          loading: false,
          isAll: false,
          isLoading: false,
          isSharePage:false,
          data1:{
            item:[
              {
                page: {
                  last: 2
                }
              }
            ]
          },
          next: 1,
          pageToken:'',
          nav:[],
          dataList_:{
            item:
              {
                page: {
                  last: 2
                }
              }
          },
          dataList:[],
          noData:null,
          noData_:null,
          data_:[],
          title:'国内'
        }
      },

      created () {
        // 暴露方法给webview
        window.appapi = api
        window.$vm = this
        this.isSharePage = appapi.isSharePage()
        // this.getInit(this.$route.params.id)
        this.appPostMessage('FullScreen')

      },
      
      mounted(){
         this.getInit()
         window.addEventListener("scroll", this.handleScroll, true);
         this.$nextTick(()=>{
           const u = navigator.userAgent
           const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
           if (isiOS) {
            try{
                document.querySelector('.date_').style.fontSize = "0.4rem";
              }catch(e){
                console.log(e)
              }
            }else{
              // alert('安卓')
              try{
                document.querySelector('.date_').style.fontSize = "0.373rem";
              }catch(e){
                console.log(e)
              }
              
            }
         })
      },
      methods: {
        //http://10.50.161.227:8492/api/v2/articles/hot24ArticleList?size=15
        //http://10.50.161.227:8492/api/v2/articles/hot24ArticleList/62?size=15
        getInit(){
          //  debugger
            this.loading = true
            this.pageToken = this.next * 1
            const pageLast = this.data1.item[0].page.last * 1
            // console.log(this.pageToken, pageLast)
            if ( this.pageToken > pageLast) {
                this.loading = false
                this.isAll = true
                return false
            }
            this.$axios.get(`${intfc_prefix_common}/api/v2/articles/hot24ArticleList?pageToken=${this.pageToken}`)
                  .then(res=> {
                      const result = res.item
                      console.log(res,'resresresres-----')
                      if (res.code === 0) {
                          this.loading = false
                          this.data1=res
                          this.noData_=result.count
                          const navList=result
                           if(this.next==1 && this.title=='国内'){
                             navList.map((v)=>{
                              if( v.categoryInfo.name=="国际" || v.categoryInfo.name=="本地"){
                                this.nav.push({
                                  name:v.categoryInfo.name,
                                  id:v.categoryInfo.id
                                })
                              }
                            })
                          }
                          if (this.data1.item && this.data1.item.length > 0 ){
                            // console.log(this.data1.item,'00000000000000',this.data_)
                            this.data_=this.data_.concat(this.data1.item)
                            this.next++
                            // console.log('this.data.item',this.next,...this.data1.item)
                          }
                            // console.log(navList,'navList',this.next)
                          
                          
                          
                          // this.blocks = result.blocks
                          // 微信分享
                          wx({
                              title: result.title,
                              // imgUrl: result.image
                          },this)

                          // 存储唤醒的数据
                          // this.$store.dispatch('saveData', result)
                      }else {
                          Toast(res.msg)
                          this.loading = false
                      }
                  })
        },

        get24Init(id){
          
            this.loading = true
            this.pageToken = this.next * 1
            // console.log(this.dataList_.item,'this.dataList_.item')
            const pageLast = this.dataList_.item.page.last * 1
            // console.log(this.pageToken, pageLast)
            if ( this.pageToken > pageLast) {
                this.loading = false
                this.isAll = true
                return false
            }
            this.$axios.get(`${intfc_prefix_common}/api/v2/articles/hot24ArticleList/${id}?pageToken=${this.pageToken}`)
            .then(res=> {
                const result = res.item
                if (res.code === 0) {
                    this.loading = false
                    this.dataList_ = res
                    this.noData=result.count
                    this.dataList=res.item
                    // console.log(typeof this.dataList,'=========',typeof this.dataList_.item,'-----------',this.dataList.list,)
                    try {
                        if (Array.isArray(this.dataList)){
                        this.dataList=this.dataList.concat(this.dataList_.item)
                        this.next++

                        // console.log('ggggggggggggggg数组')
                      }else{
                        for(var i in this.dataList_.item.list){
                          // console.log(i,this.dataList_.item.list[i],'000000')
                          this.dataList.list[i]=this.dataList_.item.list[i]
                        }

                        this.next++

                        // console.log(this.dataList,'对象this.data.item',...this.dataList.item)

                      }
                    } catch (error) {
                      console.log(error)
                    }
                    
                    // this.blocks = result.blocks
                    // 微信分享
                    wx({
                        title: result.title,
                        // imgUrl: result.image
                    },this)

                    // 存储唤醒的数据
                    // this.$store.dispatch('saveData', result)
                }else {
                    Toast(res.msg)
                    this.loading = false
                }
            })
        },

        changeID(name,title){
          this.next=1
          // if(this.isSharePage && document.body.scrollTop>320){
          //   // document.body.scrollTop=440
          //   document.getElementById("list_scroll").scrollIntoView(true)
          // }else{
            // document.body.scrollTop=340
          // }
          // document.getElementById("list_scroll").scrollIntoView(true)
          this.nav.map((v)=>{
            if(v.name==title){
              this.title=title
              return this.get24Init(v.id)
            }
          })
        },
          getDate: (date) => {
            return date.slice(0, -2) + ':00'
          },

          getTime (time) {
            let result = ''
            if (time) {
              // result = time.substring(0,10) + ' ' + time.substring(11,16)
              result = time.substring(11,16)
            }
            return result
          },

          getCount (count) {
              let result = 0
              if (count > 0) {
                  result = count
                  if (count > 999999) {
                      result = count.substring(0,count.length - 4) + '万'
                      if (count > 99999999) {
                          result = '过亿'
                      }
                  }
              }
              return result
          },

          goPath (article) {
            if (!this.isSharePage) {
                const { articleId, type, sysCode } = article;
                const obj = {
                    articleId: articleId,
                    type: type,
                    sysCode: sysCode
                }
                window.appapi.appPostMessage("goNewsDetail", JSON.stringify(obj));
                // this.appPostMessage('FullScreen')
                // console.log('FullScreen','触发')
            }else {
                window.location.href = article.shareUrl
            }
          },
         

          loadMore() {
          // console.log(this.isAll,'isAll',this.loading,'this.loading')
          if (this.isAll || this.loading) return false
          if(this.title=='国内'){this.getInit()}else{
            this.nav.map((v)=>{
              // console.log(v,'////////////')
              if(v.name==this.title ){
                return this.get24Init(v.id)
              }
            })
          }

          
          
          // this.getComment(this.$route.params.id)
          },

          appPostMessage (name, value='') {
            // 调用app原生方法
            if (name) window.appapi.appPostMessage(name, value)
          },    
          onRefresh() {
            setTimeout(() => {
              this.isLoading = false;
              this.count++;
            }, 1000);
          },
          loadImg(e) {
            e.target.style.backgroundImage = 'unset'
          },
          getLikesCount (count) {
            let result = ''
            if (count > 0) {
                result = count
                if (count > 999999) {
                    result = count.substring(0,count.length - 4) + '万'
                    if (count > 99999999) {
                        result = '过亿'
                    }
                }
            }
            return result
          },
          handleScroll(e) {
            var top_ = document.querySelector(".van-tabs__wrap");
            var imgs_ = document.querySelector(".bg_header_img");
            let scrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop;
            //  console.log(scrollTop,'body  scrollTopscrollTop')
            if(imgs_){
                let topH = this.$refs.imgHight.offsetHeight;
                let zHight=topH
                // console.log(zHight,'图片zHightzHight')

                if(this.isSharePage){
                    if(scrollTop >zHight){
                      top_.style.position='fixed';
                      top_.style.zIndex='9';
                      top_.style.top='0';
                      top_.style.clear='both';
                      top_.style.overflow='hidden';
                      top_.style._top='expression(eval(document.documentElement.scrollTop))';
                    }else{
                      top_.style.position='relative';
                    }
                }else{
                  if(scrollTop >topH){
                    top_.style.position='fixed';
                    top_.style.zIndex='99999';
                    top_.style.top='0';
                    top_.style.clear='both';
                    top_.style.overflow='hidden';
                  }else{
                    top_.style.position='relative';
                    // console.log('xia')
                  }
                     
                }
            }
            
             
      
        },
      },
      destroyed(){
        window.removeEventListener('scroll', this.handleScroll,true);
      },
      components:{
        PageCommon,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [PullRefresh.name]: PullRefresh,
        spinner: Spinner,
      }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import "~src/stylus/mixin"
    @import "~src/stylus/list"
    .wrapper
      .hours_header
        .bg_header_img
            width 100%
            height 330px
            object-fit cover
            background-size cover !important
            background-position center !important
      section 
        ul 
          .date_
            font-size:28px;
          .hours_list
            padding 0 0 10px 5px; 
            position: relative;
            &:before
              content:'';
              height:100%;
              // padding 0 0 20px 20px; 
              border-left: 2px dashed #eee;
              position :absolute;
              left:0px;
              top:5px;
              z-index:1;
            .time_red
              position: relative;
              padding-left:10px;
              font-size: 20px;
              color: #D4282B;
              margin-bottom: 10px;
              &:before
                content:'';
                width: 8px;
                height: 8px;
                background: #D4282B;
                border: 2px solid #FFB3B4;
                border-radius: 50%;
                position :absolute;
                left:-10px;
                top:5px;
                z-index:1
            li
              margin-bottom: 0.373333rem ;
              border-bottom: 0.026667rem solid #f3f3f3;
              margin-left:30px;
              .comments
                margin:0 20px;
                &:before
                  content:'';
                  display:block;
                  width: 24px;
                  height: 24px;
                  background: url('~images/yanjing2x.png') no-repeat center center;
                  background-size:contain;
                  position :absolute;
                  left:-10px;
                  top:5px;
                  z-index:1
              .hours_tag
                margin-left:30px;
                font-size: 20px;
                color: #888888;
                position : relative;
                padding-left: 20px;
              .likes_
                &:before
                  content:'';
                  display:block;
                  width: 24px;
                  height: 24px;
                  background: url('~images/like2x.png') no-repeat center center;
                  background-size:contain;
                  position :absolute;
                  left:-10px;
                  top:5px;
                  z-index:1
              time
                font-size: 20px;
              .thumbnail 
                border-radius:8px;
                width:208px;
                height:130px;
</style>
<style lang="stylus" rel="stylesheet/stylus">
.tab_list 
  margin-top:0px !important;
  .van-tabs__wrap{
    // position:absolute;
    width:100%;
    // top:110px;
    // left:0;
    // z-index:5;
    background:#fff;
    height:76px !important;
  }
  .van-tabs__nav{
    background: none;
    width:60%;
    margin:0 auto;
  }
  .van-tab{
    font-size: 34px;
    color: #222;
    line-height: 76px
    margin: 0 15px;
    font-family: FZZYSJW--GB1-0;
  }
  .van-tab--active{
    color: #D4282B;
    font-weight:400;
  }
  .van-tabs__line{
    background-color: #D4282B;
    height:6px;
  }
  .mint-spinner-fading-circle {
    left: 50%;
    margin-left: -14px;
}

</style>


// WEBPACK FOOTER //
// page-24hours.vue?157976ab